import * as algoliasearch from 'algoliasearch/lite';

import TettraIndex from '../schemas/TettraUniSchema';
import { SEARCH_INDEX, RESOURCE_MODEL } from '../utilities/CONSTANTS';

const MAX_SUGGESTIONS = 10;

const UniSearch = (appId, searchKey, team = null, source = null, models = [RESOURCE_MODEL.PAGE]) => {
    const client = algoliasearch(appId, searchKey);
    const index = client.initIndex(SEARCH_INDEX);
    const modelsFilter = models.map(model => `model:${model}`).join(' OR ');
    const searchParams = {
        hitsPerPage: MAX_SUGGESTIONS,
        attributesToRetrieve: ['objectID', 'title', 'last_updated', 'url', 'category_id', 'model', 'icon_url'],
        restrictSearchableAttributes: ['title'],
        filters: `(${modelsFilter}) AND __soft_deleted=0`,
    };

    if (team !== null && source !== null) {
        searchParams.analyticsTags = [`team:${team}`, `source:${source}`];
    }

    return (searchQuery) => new Promise((resolve, reject) => {
        index.search(searchQuery, searchParams)
            .then(({ hits }) => resolve(hits.map((data) => (new TettraIndex(data)))))
            .catch(reject);
    });
};

export default UniSearch;
